import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Baibhav Sureka</span>{" "}
            from <span className="purple">Bihar, India.</span>
            <br />I am currently pursuing a B.Tech in{" "}
            <b className="purple">Computer Science and Engineering (IoT)</b> at VIT
            Vellore with a <b className="purple">CGPA of 9.08/10.0</b>.
            <br />
            <br />
            My expertise includes{" "}
            <b className="purple">
              JavaScript, TypeScript, React.js, Next.js, Node.js, and AI/ML technologies.
            </b> I am passionate about building scalable web applications, optimizing
            backend performance, and exploring FinTech solutions.
            <br />
            <br />
            Some highlights of my journey:
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Currently interning at <b className="purple">LinkMoney</b> (FinTech Startup) as Software Engineer Intern
            </li>
            <li className="about-activity">
              <ImPointRight /> Solved <b className="purple">600+ problems</b> on LeetCode, Codeforces, and CodeChef
            </li>
            <li className="about-activity">
              <ImPointRight /> Achieved <b className="purple">Top 5%</b> in LeetCode Weekly Contest 409 (Rank 1,837 out of 40,000+)
            </li>
            <li className="about-activity">
              <ImPointRight /> Secured <b className="purple">7th Position</b> out of 300+ teams at DEVSOC 2024 Hackathon
            </li>
            <li className="about-activity">
              <ImPointRight /> Contributed to open-source and research projects
            </li>
          </ul>
          <br />
          <p>Beyond coding, I enjoy:</p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Online Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Reading Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Traveling and exploring new places
            </li>
          </ul>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
